import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Apache Junction",
    route: "/cities/apache-junction",
    tagline: "Pinal County expedited passport services at the base of the Superstition Mountains",
    highlights: ["Gateway to Tonto National Forest", "Serving Gold Canyon, Queen Valley"],
    badge: null,
    status: "live",
  },
  {
    name: "Avondale",
    route: "/cities/avondale",
    tagline: "West Valley expedited passport processing — serving Luke AFB families and Goodyear commuters",
    highlights: ["West Valley coverage", "Serving Goodyear, Litchfield Park"],
    badge: null,
    status: "live",
  },
  {
    name: "Buckeye",
    route: "/cities/buckeye",
    tagline: "West Valley fastest-growing city with expedited passport services",
    highlights: ["West Valley coverage", "Serving Verrado, Tartesso, Sun City West"],
    badge: null,
    status: "live",
  },
  {
    name: "Bullhead City",
    route: "/cities/bullhead-city",
    tagline: "Mohave County expedited passport services on the Colorado River",
    highlights: ["Colorado River corridor coverage", "Serving Laughlin, Fort Mohave, Mohave Valley"],
    badge: null,
    status: "live",
  },
  {
    name: "Casa Grande",
    route: "/cities/casa-grande",
    tagline: "Pinal County expedited passport services on the I-10 corridor between Phoenix and Tucson",
    highlights: ["I-10 corridor coverage", "Serving Eloy, Coolidge, Maricopa"],
    badge: null,
    status: "live",
  },
  {
    name: "Chandler",
    route: "/cities/chandler",
    tagline: "Southeast Valley expedited passport processing — Intel, Microchip Technology, and tech corridor workers",
    highlights: ["Southeast Valley coverage", "Serving Gilbert, Tempe, Mesa"],
    badge: null,
    status: "live",
  },
  {
    name: "Cottonwood",
    route: "/cities/cottonwood",
    tagline: "Verde Valley expedited passport services — skip the 85-mile drive to Phoenix",
    highlights: ["Verde Valley coverage", "Serving Clarkdale, Jerome, Camp Verde, Sedona"],
    badge: null,
    status: "live",
  },
  {
    name: "Flagstaff",
    route: "/cities/flagstaff",
    tagline: "Northern Arizona expedited passport services — NAU students, Grand Canyon workers, and mountain town residents",
    highlights: ["Gateway to Grand Canyon and Sedona", "Serving Williams, Bellemont, Munds Park"],
    badge: null,
    status: "live",
  },
  {
    name: "Gilbert",
    route: "/cities/gilbert",
    tagline: "Southeast Valley family-friendly expedited passport services",
    highlights: ["Southeast Valley coverage", "Serving San Tan Valley, Queen Creek, Chandler"],
    badge: null,
    status: "live",
  },
  {
    name: "Glendale",
    route: "/cities/glendale-az",
    tagline: "West Valley expedited passport processing — diverse Glendale community and sports industry workers",
    highlights: ["West Valley coverage", "Serving Peoria, El Mirage, Surprise"],
    badge: null,
    status: "live",
  },
  {
    name: "Goodyear",
    route: "/cities/goodyear",
    tagline: "West Valley expedited passport services — Lucid Air, Amazon logistics, Luke AFB, and Estrella Mountain residents",
    highlights: ["West Valley coverage", "Serving Avondale, Buckeye, Litchfield Park"],
    badge: null,
    status: "live",
  },
  {
    name: "Green Valley",
    route: "/cities/green-valley",
    tagline: "Southern Arizona expedited passport services for retirees, snowbirds, and Mexico border travelers",
    highlights: ["Southern Arizona coverage", "Serving Sahuarita, Amado, Tubac, Rio Rico"],
    badge: null,
    status: "live",
  },
  {
    name: "Holbrook",
    route: "/cities/holbrook",
    tagline: "Navajo County expedited passport services on Historic Route 66 — serving northeast Arizona without a 200-mile drive",
    highlights: ["Northeast Arizona coverage", "Serving Joseph City, Winslow, Snowflake, Taylor"],
    badge: null,
    status: "live",
  },
  {
    name: "Kingman",
    route: "/cities/kingman",
    tagline: "Mohave County expedited passport services — between Phoenix and Las Vegas on Historic Route 66",
    highlights: ["Northwest Arizona coverage", "Serving Golden Valley, Peach Springs, Dolan Springs"],
    badge: null,
    status: "live",
  },
  {
    name: "Lake Havasu City",
    route: "/cities/lake-havasu-city",
    tagline: "Colorado River expedited passport services — retirement community, London Bridge, and outdoor recreation travelers",
    highlights: ["Colorado River corridor coverage", "Serving Parker, Topock, Mohave Valley"],
    badge: null,
    status: "live",
  },
  {
    name: "Marana",
    route: "/cities/marana",
    tagline: "Northwest Tucson metro expedited passport services — Raytheon aerospace workers, Dove Mountain residents, Tortolita foothills families",
    highlights: ["Northwest Tucson metro coverage", "Serving Dove Mountain, Picture Rocks, Saddlebrooke"],
    badge: null,
    status: "live",
  },
  {
    name: "Maricopa",
    route: "/cities/maricopa",
    tagline: "Pinal County expedited passport services — young families, first-time applicants, Phoenix commuters, and Ak-Chin community",
    highlights: ["Pinal County coverage", "Serving Ak-Chin, Mobile, Stanfield, Casa Grande"],
    badge: null,
    status: "live",
  },
  {
    name: "Mesa",
    route: "/cities/mesa",
    tagline: "East Valley expedited passport services in Arizona's third-largest city — Boeing aerospace, LDS missions, ASU Polytechnic",
    highlights: ["East Valley coverage", "Serving Gilbert, Chandler, Apache Junction, Tempe"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Nogales",
    route: "/cities/nogales",
    tagline: "Santa Cruz County border community expedited passport services — cross-border families and international trade workers",
    highlights: ["Border corridor coverage", "Serving Rio Rico, Tubac, Patagonia, Amado"],
    badge: null,
    status: "live",
  },
  {
    name: "Oro Valley",
    route: "/cities/oro-valley",
    tagline: "Northwest Tucson metro expedited passport services — Catalina foothills retirees, Saddlebrooke active adults, golf community",
    highlights: ["Northwest Tucson metro coverage", "Serving Catalina, Saddlebrooke, Tortolita"],
    badge: null,
    status: "live",
  },
  {
    name: "Page",
    route: "/cities/page-az",
    tagline: "Coconino County expedited passport services near Lake Powell — skip the 300-mile Phoenix drive",
    highlights: ["Northern Arizona coverage", "Serving Kaibito, LeChee, Bitter Springs, Kanab UT"],
    badge: null,
    status: "live",
  },
  {
    name: "Paradise Valley",
    route: "/cities/paradise-valley",
    tagline: "Premium expedited passport services for Camelback Mountain estate residents and resort executives",
    highlights: ["Northeast Phoenix metro coverage", "Serving North Scottsdale, Arcadia, Biltmore"],
    badge: null,
    status: "live",
  },
  {
    name: "Payson",
    route: "/cities/payson",
    tagline: "Mogollon Rim Country expedited passport services — skip the 90-mile mountain drive to Phoenix",
    highlights: ["Rim Country coverage", "Serving Pine, Strawberry, Star Valley, Heber-Overgaard"],
    badge: null,
    status: "live",
  },
  {
    name: "Peoria",
    route: "/cities/peoria-az",
    tagline: "Northwest Valley expedited passport services — Lake Pleasant, Vistancia, P83, and spring training",
    highlights: ["Northwest Valley coverage", "Serving Vistancia, Surprise, Sun City, El Mirage"],
    badge: null,
    status: "live",
  },
  {
    name: "Phoenix",
    route: "/cities/phoenix",
    tagline: "Arizona's capital — fastest expedited passport service without the agency appointment wait",
    highlights: ["Central Arizona hub", "Serving all Phoenix neighborhoods, ASU, and aerospace industry"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Prescott",
    route: "/cities/prescott",
    tagline: "Yavapai County expedited passport services in the mile-high city",
    highlights: ["Central Arizona coverage", "Serving Prescott Valley, Chino Valley, Dewey-Humboldt"],
    badge: null,
    status: "live",
  },
  {
    name: "Prescott Valley",
    route: "/cities/prescott-valley",
    tagline: "Yavapai County expedited passport services in the growing Quad Cities area",
    highlights: ["Central Arizona coverage", "Serving Prescott, Chino Valley, Dewey-Humboldt"],
    badge: null,
    status: "live",
  },
  {
    name: "Queen Creek",
    route: "/cities/queen-creek",
    tagline: "Southeast Valley expedited passport services in a rapidly growing community",
    highlights: ["Southeast Valley coverage", "Serving San Tan Valley, Gilbert, Mesa"],
    badge: null,
    status: "live",
  },
  {
    name: "Sahuarita",
    route: "/cities/sahuarita",
    tagline: "South Tucson metro area expedited passport services for southern Arizona",
    highlights: ["South Tucson metro coverage", "Serving Green Valley, Tubac, Amado"],
    badge: null,
    status: "live",
  },
  {
    name: "San Luis",
    route: "/cities/san-luis",
    tagline: "Yuma County expedited passport services on the US-Mexico border",
    highlights: ["Southwest Arizona coverage", "Serving Somerton, Gadsden, Wellton"],
    badge: null,
    status: "live",
  },
  {
    name: "Scottsdale",
    route: "/cities/scottsdale",
    tagline: "Northeast Phoenix metro premium expedited passport services — Mayo Clinic, Barrett-Jackson, resort executives",
    highlights: ["Northeast Phoenix metro coverage", "Serving Paradise Valley, Fountain Hills, Carefree"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Sedona",
    route: "/cities/sedona",
    tagline: "Yavapai & Coconino County expedited passport services in red rock country",
    highlights: ["Red Rock Country coverage", "Serving Village of Oak Creek, Cornville, Rimrock"],
    badge: null,
    status: "live",
  },
  {
    name: "Sierra Vista",
    route: "/cities/sierra-vista",
    tagline: "Cochise County expedited passport services near Fort Huachuca",
    highlights: ["Southeast Arizona coverage", "Serving Huachuca City, Tombstone, Bisbee"],
    badge: null,
    status: "live",
  },
  {
    name: "Show Low",
    route: "/cities/show-low",
    tagline: "Navajo County expedited passport services in the White Mountains",
    highlights: ["White Mountains coverage", "Serving Pinetop-Lakeside, Snowflake, Taylor"],
    badge: null,
    status: "live",
  },
  {
    name: "Somerton",
    route: "/cities/somerton",
    tagline: "Yuma County expedited passport services near the California border",
    highlights: ["Southwest Arizona coverage", "Serving San Luis, Gadsden, Cocopah"],
    badge: null,
    status: "live",
  },
  {
    name: "Surprise",
    route: "/cities/surprise",
    tagline: "Northwest Valley expedited passport services in a rapidly growing suburb",
    highlights: ["Northwest Valley coverage", "Serving El Mirage, Sun City, Sun City West"],
    badge: null,
    status: "live",
  },
  {
    name: "Tempe",
    route: "/cities/tempe",
    tagline: "Central Phoenix metro expedited passport services near ASU",
    highlights: ["Central Phoenix metro coverage", "Serving Mesa, Scottsdale, Chandler"],
    badge: null,
    status: "live",
  },
  {
    name: "Tucson",
    route: "/cities/tucson",
    tagline: "Southern Arizona expedited passport services — University of Arizona, Davis-Monthan AFB, Raytheon",
    highlights: ["Southern Arizona coverage", "Serving Oro Valley, Marana, Green Valley, Sahuarita"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Winslow",
    route: "/cities/winslow",
    tagline: "Navajo County expedited passport services on Historic Route 66",
    highlights: ["Northeast Arizona coverage", "Serving Holbrook, Joseph City, Leupp"],
    badge: null,
    status: "live",
  },
  {
    name: "Yuma",
    route: "/cities/yuma",
    tagline: "Yuma County expedited passport services on the Colorado River and California border",
    highlights: ["Southwest Arizona coverage", "Serving Fortuna Foothills, San Luis, Somerton"],
    badge: null,
    status: "live",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function ArizonaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Arizona Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Arizona Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Arizona</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Arizona locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}